import React, { useEffect } from 'react';
import useAuth from '../../hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import { INDEX_URL } from '../../utils/constants';
import ComingSoon from '../../components/ComingSoon/ComingSoon';

const renderHTML = (rawHTML: string) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });
const SalesReportPage = () => {
    const { user } = useAuth();
    const navigate = useNavigate();
    useEffect(() => {
        if (user?.user_type !== 'admin') {
            navigate(INDEX_URL); // Redirect to dashboard if not admin
        }
    }, [user, navigate]);
    return(
        <React.Fragment>
            <main className="techtop-middle-div">
                <section className="techtop-quality-control-section pt-2 pb-3">
                    <div className="container">
                        {/* Page Title */}
                        <div className="row">
                            <div className="col-md-12">
                                <div className="techtop-default-title2">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <h1 className="m-0 dark-color1">Techtop Internal Portal</h1>
                                        </div>
                                        <div className="col-md-6 text-end">
                                            <h1 className="m-0 dark-color1">{user.name}</h1>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="py-2 text-center m-0 mt-4">
                                    {user.default_content ? renderHTML(user.default_content) : (<ComingSoon/>)}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </React.Fragment>
    )
}

export default SalesReportPage;